import API from '@/services/GraphQl';
import {
  lastUniqByIdAndSortByRating, sortNumberByRating,
} from '@/helpers/utils';
export const actions = {
  async getListCommunityCollections({ commit, state, dispatch }, { uploadAll = false, spinner = false, spinnerOnFirstLoad = false }) {
    const nextTokenForRequest = state.nextToken;
    if (!nextTokenForRequest) {
      commit('setCommunityCollectionsList', []);
      commit('setCommunityCollectionsListPageOptions', null);
    }
    if (spinner) {
      commit('spinner', true, {
        root: true,
      });
    }
    const { data } = await API.listCommunityCollections({
      nextToken: nextTokenForRequest,
    });
    const { communityCollectionsList } = state;
    const { data: listOfCollections, ...rest } = data.response;
    commit('setCommunityCollectionsList', nextTokenForRequest ? lastUniqByIdAndSortByRating([
      ...communityCollectionsList, ...listOfCollections,
    ]) : listOfCollections);
    commit('setNextToken', data.response.nextToken);
    commit('setCommunityCollectionsListPageOptions', rest);
    if (spinner) {
      commit('spinner', false, {
        root: true,
      });
    }
    if (uploadAll && data.response.nextToken) {
      dispatch('getListCommunityCollections', {
        uploadAll,
        spinnerOnFirstLoad,
        ...!spinnerOnFirstLoad && {
          spinner: true,
        },
      });
    }
  },
  async manageCollectionRatingBoost({ commit, state, dispatch }, payload) {
    if ( payload.action === 'reduce' && payload.item.rating - Number.parseInt(payload.value) < 0) {
      commit('openSnackBar', {
        text: 'Please enter another value that is less than or equal to the collection rating',
      }, {
        root: true,
      });
      return;
    }
    commit('spinner', true, {
      root: true,
    });
    const { data } = await API.manageCollectionRatingBoost({
      collectionId: payload.item.id,
      libraryId: payload.item.libraryId,
      number: Number.parseInt(payload.value),
      operation: payload.action === 'boost' ? 'increase' : 'reduce',
    });
    // data.response.boost = payload.action === 'boost';
    // commit('editCollection', data.response);
    const updatedCommunityCollectionsList = state.communityCollectionsList.map(c => {
      if (c.id == payload.item.id) {
        return {
          ...c,
          rating: data.response.rating,
        };
      }
      return c;
    });
    commit('setCommunityCollectionsList', sortNumberByRating(updatedCommunityCollectionsList));
    commit('spinner', false, {
      root: true,
    });
  },
};
